import { render, staticRenderFns } from "./ProjectRequestList.vue?vue&type=template&id=81151990&"
import script from "./ProjectRequestList.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports